import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  validateName,
  validateUsername,
  validatePassword,
  validateConfirmPassword,
  validateEmail,
  validatePhone,
} from "../utils/validation";

export default function SignUp() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: "",
    username: "",
    email: "",
    phone: "",
    password: "",
    confirm: "",
  });

  const [errors, setErrors] = useState({});

  // Handle input change
  function handleChange(e) {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  }

  // Validate all fields
  function validateAll() {
    const newErrors = {
      name: validateName(form.name),
      username: validateUsername(form.username),
      email: validateEmail(form.email),
      phone: validatePhone(form.phone),
      password: validatePassword(form.password, form.username),
      confirm: validateConfirmPassword(form.confirm, form.password),
    };
    setErrors(newErrors);
    return Object.values(newErrors).every((err) => !err);
  }

  // Handle submit
  function handleSubmit(e) {
    e.preventDefault();
    if (!validateAll()) return;

    // Save in localStorage (simulated signup)
    localStorage.setItem(
      "demoUser",
      JSON.stringify({
        username: form.username,
        email: form.email,
        password: form.password,
      })
    );

    // Redirect to login
    navigate("/", { state: { signedUp: true } });
  }

  return (
    <div className="container d-flex justify-content-center align-items-center min-vh-100">
      <div className="col-12 col-md-8 col-lg-6">
        <div className="card shadow-lg border-0 rounded-4">
          <div className="card-body p-5">
            <h2 className="mb-4 text-center fw-bold">Create An Account</h2>
            <p className="text-muted text-center mb-4">
              Please fill in the form to sign up
            </p>

            <form onSubmit={handleSubmit} noValidate>
              {/* Full Name */}
              <div className="mb-3">
                <label className="form-label">Full Name</label>
                <input
                  type="text"
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  className={`form-control ${errors.name ? "is-invalid" : ""}`}
                  placeholder="e.g. Chinedu Okotu"
                />
                {errors.name && (
                  <div className="invalid-feedback">{errors.name}</div>
                )}
              </div>

              {/* Username */}
              <div className="mb-3">
                <label className="form-label">Username</label>
                <input
                  type="text"
                  name="username"
                  value={form.username}
                  onChange={handleChange}
                  className={`form-control ${
                    errors.username ? "is-invalid" : ""
                  }`}
                  placeholder="Choose a username"
                />
                {errors.username && (
                  <div className="invalid-feedback">{errors.username}</div>
                )}
              </div>

              {/* Email */}
              <div className="mb-3">
                <label className="form-label">Email (Gmail only)</label>
                <input
                  type="email"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  className={`form-control ${errors.email ? "is-invalid" : ""}`}
                  placeholder="example@gmail.com"
                />
                {errors.email && (
                  <div className="invalid-feedback">{errors.email}</div>
                )}
              </div>

              {/* Phone */}
              <div className="mb-3">
                <label className="form-label">Phone (with country code)</label>
                <input
                  type="text"
                  name="phone"
                  value={form.phone}
                  onChange={handleChange}
                  className={`form-control ${errors.phone ? "is-invalid" : ""}`}
                  placeholder="+2348012345678"
                />
                {errors.phone && (
                  <div className="invalid-feedback">{errors.phone}</div>
                )}
              </div>

              {/* Password */}
              <div className="mb-3">
                <label className="form-label">Password</label>
                <input
                  type="password"
                  name="password"
                  value={form.password}
                  onChange={handleChange}
                  className={`form-control ${
                    errors.password ? "is-invalid" : ""
                  }`}
                  placeholder="Enter a strong password"
                />
                {errors.password && (
                  <div className="invalid-feedback">{errors.password}</div>
                )}
              </div>

              {/* Confirm Password */}
              <div className="mb-4">
                <label className="form-label">Confirm Password</label>
                <input
                  type="password"
                  name="confirm"
                  value={form.confirm}
                  onChange={handleChange}
                  className={`form-control ${
                    errors.confirm ? "is-invalid" : ""
                  }`}
                  placeholder="Re-enter your password"
                />
                {errors.confirm && (
                  <div className="invalid-feedback">{errors.confirm}</div>
                )}
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                className="btn btn-dark w-100 py-2 fw-semibold rounded-3"
              >
                Sign Up
              </button>
            </form>

            {/* Login Link */}
            <div className="text-center mt-3">
              <span className="text-muted">Already have an account? </span>
              <Link to="/" className="fw-semibold">
                Log in
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
